// Column IDs used across the application
export const LAST_COMPLETED_DATE_COLUMN_ID = "date_mky2cdqd"; // Weekly Checks
export const METER_READINGS_LAST_COMPLETED_DATE_COLUMN_ID = "date_mky2fkmz"; // Meter Readings
export const TASKS_DESCRIPTION_COLUMN_ID = "long_text_mky9vsce"; // TASKS board description column
export const PROPERTIES_BOARD_ID = "5087849943";
export const WEEKLY_CHECKS_BOARD_ID = 5088246586;
export const METER_READINGS_BOARD_ID = 5088238378;
export const TASKS_BOARD_ID = 5088243937;
export const REPORTS_BOARD_ID = "5088279319";
export const CLEANING_CHECKS_BOARD_ID = 5088644309;
export const BOOKINGS_BOARD_ID = 5088566398;
export const FILE_COLUMN_ID = "file_mky3bmn7";
export const REPORTS_PROPERTY_COLUMN_ID = "board_relation_mky3yhcf";
export const TASKS_PROPERTY_COLUMN_ID = "board_relation_mky2d8h0";
export const TASKS_DUE_DATE_COLUMN_ID = "date4";
export const TASKS_DESCRIPTION_COLUMN_ID_FULL = "long_text_mky9vsce";
export const WATER_COLUMN_ID = "file_mkyf7jcg"; // Water meter photo file column
export const ELECTRICITY_COLUMN_ID = "text_mky97tgp";
export const GAS_COLUMN_ID = "file_mkyf5970"; // Gas meter photo file column
export const METER_READINGS_NOTES_COLUMN_ID = "text_mkyj5fvd"; // Meter Readings Notes column
export const ELECTRICITY_DATE_COLUMN_ID = "date_mkzay4ke"; // Electricity reading date
export const WATER_DATE_COLUMN_ID = "date_mkza464v"; // Water reading date
export const GAS_DATE_COLUMN_ID = "date_mkzac0ze"; // Gas reading date
export const TIME_SPENT_COLUMN_ID = "text_mkybm2mh"; // TASKS board Time Spent column
export const TIME_TRACKING_COLUMN_ID = "color_mkybj7rw"; // TASKS board Time Tracking column
export const TASKS_FILE_COLUMN_ID = "file_mkyssk15"; // TASKS board file column for images
export const TASKS_COMMENTS_COLUMN_ID = "text_mkysxesd"; // TASKS board comments column
export const WEEKLY_CHECKS_TYPE_COLUMN_ID = "color_mky2n4xa"; // Weekly Checks Type column (Weekly Check / Monthly Check)

// Properties board columns
export const PROPERTY_KEYBOX_COLUMN_ID = "text_mkyj814"; // Keybox
export const PROPERTY_ALARM_COLUMN_ID = "text_mkyj7axn"; // Alarm
export const PROPERTY_DOOR_GATE_CODE_COLUMN_ID = "text_mkyjmb3t"; // Door/Gate Code
export const PROPERTY_ADDRESS_COLUMN_ID = "property_address"; // Location/Address

// Known person column IDs per board
export const KNOWN_PERSON_COLUMN_IDS = {
  5088243937: "dropdown_mky4syyj", // TASKS board
  5088246586: "dropdown_mky8d81k", // Weekly Checks board
  5088238378: "dropdown_mky8cgyg", // Meter Readings board
  5088644309: "dropdown_mkybk7w6", // Cleaning Checks board
};

// Board IDs array for checking person columns
export const BOARDS_TO_CHECK = [TASKS_BOARD_ID, WEEKLY_CHECKS_BOARD_ID, METER_READINGS_BOARD_ID, CLEANING_CHECKS_BOARD_ID];

// Default person column ID fallback
export const DEFAULT_PERSON_COLUMN_ID = "dropdown_mky4syyj";

